'use client';

import { c as _c } from "react/compiler-runtime";
import { Body, Button, Separator } from '@bridge/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Image from 'next/image';
import { faShieldKeyhole } from '@icons/classic/regular';
import GoogleLogo from 'public/logo-google.png';
import type { ReactElement } from 'react';
interface AuthMethodSelectorProps {
  onGoogleClick: () => void;
  onSSOClick: () => void;
}
const AuthMethodSelector = t0 => {
  const $ = _c(13);
  const {
    onGoogleClick,
    onSSOClick
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Image alt="Google Logo" height={20} src={GoogleLogo} width={20} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== onGoogleClick) {
    t2 = <Button className="h-12 w-full" onClick={onGoogleClick} size="lg" variant="secondary">{t1}Continue with Google</Button>;
    $[1] = onGoogleClick;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <FontAwesomeIcon icon={faShieldKeyhole} />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== onSSOClick) {
    t4 = <Button className="h-12 w-full" onClick={onSSOClick} size="lg" variant="secondary">{t3}Continue with SSO</Button>;
    $[4] = onSSOClick;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t2 || $[7] !== t4) {
    t5 = <div className="space-y-2">{t2}{t4}</div>;
    $[6] = t2;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="absolute inset-0 flex items-center" aria-hidden="true"><Separator /></div>;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="relative my-8">{t6}<div className="relative flex justify-center"><Body className="bg-background-primary px-4 tracking-wide text-content-secondary uppercase" size="xs">Or</Body></div></div>;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t5) {
    t8 = <>{t5}{t7}</>;
    $[11] = t5;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  return t8;
};
export default AuthMethodSelector;